import request from '@/utils/request'

export function findOrderSummaryFinanceOrderTypeOptions() {
  return request({
    url: '/order_summary/finance_orders/order_type_options',
    method: 'get'
  })
}

export function findOrderSummaryFinancePaymentStatusOptions() {
  return request({
    url: '/order_summary/finance_orders/payment_status_options',
    method: 'get'
  })
}

export function findOrderSummaryFinanceInvoiceStatusOptions() {
  return request({
    url: '/order_summary/finance_orders/invoice_status_options',
    method: 'get'
  })
}

export function findOrderSummaryFinanceOrders(params) {
  return request({
    url: '/order_summary/finance_orders',
    method: 'get',
    params
  })
}

export function getOrderSummaryFinanceOrderDetail(id) {
  return request({
    url: `/order_summary/finance_orders/${id}/detail`,
    method: 'get'
  })
}

export function batchOrderSummaryFinancePayment(data) {
  return request({
    url: '/order_summary/finance_orders/batch_payment_status',
    method: 'post',
    data
  })
}

export function batchOrderSummaryFinanceInvoice(data) {
  return request({
    url: '/order_summary/finance_orders/batch_invoice_status',
    method: 'post',
    data
  })
}

export function exportOrderSummaryFinanceOrders(data) {
  return request({
    url: '/order_summary/finance_orders/export',
    method: 'post',
    data
  })
}

// 查询订单汇总-分佣订单列表
export function findOrderSummaryCommissionOrders(params) {
  return request({
    url: '/order_summary/commission_orders',
    method: 'get',
    params: params
  })
}

// 查询订单汇总-分佣订单单行详情（懒加载）
export function getOrderSummaryCommissionOrderDetail(id) {
  return request({
    url: `/order_summary/commission_orders/${id}/detail`,
    method: 'get'
  })
}

export function exportOrderSummaryCommissionOrders(data) {
  return request({
    url: '/order_summary/commission_orders/export',
    method: 'post',
    data
  })
}
